import { VizPreviewCtrl } from '../controllers/VizPreviewCtrl';
import { Module } from '../Module';

Module.instance().directive('tbDevicePreview',
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'vizPreview.html',
      scope: {
        vizPath: '@'
      },
      controller: VizPreviewCtrl
    };
  }
);
